import { getFirestore, doc, updateDoc } from "firebase/firestore";

const patientService = {
  updatePatientData: async (patientId, updatedData) => {
    const db = getFirestore();
    const patientRef = doc(db, "registeredPatients", patientId);

    const updatedFields = Object.fromEntries(
      Object.entries(updatedData).filter(
        ([key, value]) => key !== "age" && value !== ""
      )
    );

    await updateDoc(patientRef, updatedFields);
  },
};

export default patientService;
